(() => {
  const selectors = {
    header: '.header',
    menu: '.headerMenu',
    menuItem: '.headerMenu__listItem',
    menuItemButton: '.listItem__title--js',
    grandList: '.content__grandList',
    childItem: '.listChild',
    bodyOverlay: '.bodyOverlay',
    body: 'body',

    menuItemActiveClass: 'headerMenu__listItem--active',
    grandListActiveClass: 'content__grandList--active',
    bodyOverlayActiveClass: 'bodyOverlay--active',
    childItemActiveClass: 'listChild--active',
  }
  const header = document.querySelector(selectors.header);
  const menu = document.querySelector(selectors.menu);
  const menuItemArray = menu.querySelectorAll(selectors.menuItem);
  const menuItemButtonArray = menu.querySelectorAll(selectors.menuItemButton);
  const childItemArray = menu.querySelectorAll(selectors.childItem);
  const grandListArray = menu.querySelectorAll(selectors.grandList);
  const bodyOverlay = document.querySelector(selectors.bodyOverlay);
  const body = document.querySelector(selectors.body);

  document.documentElement.style.setProperty('--header-height', header.offsetHeight + "px");

  // show second level menu if it exist
  function showSecondLevel(menuButton) {
    const menuItem = menuButton.closest(selectors.menuItem);

    if (!menuItem.classList.contains(selectors.menuItemActiveClass)) {
      closeAllList(menuItemArray);
      menuItem.classList.add(selectors.menuItemActiveClass);
      bodyOverlay.classList.add(selectors.bodyOverlayActiveClass);
    }
  }
  // show third level menu if it exist
  function showThirdLevel(child) {
    const currentList = menu.querySelector(`[data-child-category=${child.dataset.category}]`)
    unCheckAllSecondLevel(childItemArray);
    if (currentList) {
      if (currentList.classList.contains(selectors.grandListActiveClass)) {
        currentList.classList.remove(selectors.grandListActiveClass);
        child.classList.remove(selectors.childItemActiveClass);
      } else {
        closeAllSecondList(grandListArray);
        currentList.classList.add(selectors.grandListActiveClass);
        child.classList.add(selectors.childItemActiveClass);
      }
    } else {
      closeAllSecondList(grandListArray);
    }
  }
  //  close megamenu
  function closeAllList(menuItems) {
    bodyOverlay.classList.remove(selectors.bodyOverlayActiveClass);
    body.classList.remove('inactive');
    closeAllSecondList(grandListArray);
    menuItems.forEach(menuItem => {
      menuItem.classList.remove(selectors.menuItemActiveClass);
    });
  }
  // close 3rd level menu
  function closeAllSecondList(grandLists) {
    unCheckAllSecondLevel(childItemArray);
    grandLists.forEach(grandList => {
      grandList.classList.remove(selectors.grandListActiveClass);
    });
  }
  // remove all active class from second level link
  function unCheckAllSecondLevel(childItemArray) {
    childItemArray.forEach(child => {
      child.classList.remove(selectors.childItemActiveClass);
    });
  }

  menuItemButtonArray.forEach(menuButton => {
    menuButton.addEventListener('click', (event) => {
      showSecondLevel(event.currentTarget);
      body.classList.add('inactive');
    });
  });

  childItemArray.forEach(child => {
    child.addEventListener('click', (event) => {
      showThirdLevel(event.currentTarget);
    })
  });

  bodyOverlay.addEventListener('click', () => {
    closeAllList(menuItemArray);
  });
})();
